var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.762,
    height: 48.681,
    viewBox: "0 0 39.762 48.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_150881",
    "data-name": "Rect\\xE1ngulo 150881",
    width: 39.762,
    height: 48.681,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170218",
    "data-name": "Grupo 170218",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170217",
    "data-name": "Grupo 170217",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86258",
    "data-name": "Trazado 86258",
    d: "M39.727,38.769,36.288,12.257A4.205,4.205,0,0,0,32.129,8.6H28.444V6.624a6.624,6.624,0,1,0-13.247,0V8.6H11.513a4.206,4.206,0,0,0-4.16,3.654L3.914,38.769A4.194,4.194,0,0,0,8.073,43.5h27.5a4.192,4.192,0,0,0,4.159-4.733M16.042,6.624a5.779,5.779,0,1,1,11.557,0v6.75H16.042Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86259",
    "data-name": "Trazado 86259",
    d: "M19.189,9.448h5.264a.423.423,0,1,0,0-.845H19.189a.423.423,0,1,0,0,.845",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86260",
    "data-name": "Trazado 86260",
    d: "M19.208,33.8a1.753,1.753,0,1,0-2.884-1.993l-2.536,3.6a1.753,1.753,0,0,0-3.093-.4,1.753,1.753,0,0,0-3.1-.392l-.065.092a1.753,1.753,0,0,0-3.1-.392L1.035,39.128A4.274,4.274,0,0,0,.3,42.256a5.446,5.446,0,0,0,2.678,4.82,7.1,7.1,0,0,0,3.8,1.353,3.192,3.192,0,0,0,2.058-.664A4.737,4.737,0,0,0,12.5,46.381a2.809,2.809,0,0,1,1.66-.922l2.371-.389a1.753,1.753,0,0,0,1.357-2.3,1.784,1.784,0,0,0-2-1.144l-2.355.408a.054.054,0,0,1-.06-.026.054.054,0,0,1,0-.066Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86261",
    "data-name": "Trazado 86261",
    d: "M19.208,33.8a1.753,1.753,0,1,0-2.884-1.993l-2.536,3.6a1.753,1.753,0,0,0-3.093-.4,1.753,1.753,0,0,0-3.1-.392l-.065.092a1.753,1.753,0,0,0-3.1-.392L1.035,39.128A4.274,4.274,0,0,0,.3,42.256a5.446,5.446,0,0,0,2.678,4.82,7.1,7.1,0,0,0,3.8,1.353,3.192,3.192,0,0,0,2.058-.664A4.737,4.737,0,0,0,12.5,46.381a2.809,2.809,0,0,1,1.66-.922l2.371-.389a1.753,1.753,0,0,0,1.357-2.3,1.784,1.784,0,0,0-2-1.144l-2.355.408a.054.054,0,0,1-.06-.026.054.054,0,0,1,0-.066Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.505
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86262",
    "data-name": "Trazado 86262",
    d: "M14.445,30.805a3.845,3.845,0,0,1,.6-1.31,3.887,3.887,0,1,1,5.324,5.478",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.745
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolsa);
export default __webpack_public_path__ + "static/media/Bolsa.71605ed6c8669734f8607a8b97eaeba8.svg";
export { ForwardRef as ReactComponent };